import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import "../home.css";

// Import required modules
import { Autoplay, Pagination } from "swiper/modules";
import { Link } from "react-router-dom";

const MiraiHomeHero = () => {
  const data = [
    {
      id: "1",
      img: "https://i0.wp.com/mytravelation.com/wp-content/uploads/2023/11/Dhaka.jpeg",
      text: "Welcome to Dhaka",
    },
    {
      id: "2",
      img: "https://cdn.pixabay.com/photo/2017/03/27/13/25/city-2178705_1280.jpg",
      text: "Explore Beautiful Landscapes",
    },
  ];

  return (
    <div className="relative w-full lg:h-[800px] sm:h-[350px] ">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-70 z-10"></div>

      {/* Text */}
      <div className="absolute inset-0 z-20 flex items-center max-w-screen-2xl mx-auto p-4">
        <div className="">
          <h1 className="text-white lg:text-6xl sm:text-2xl font-jost font-bold">
            Discover the World with Us
          </h1>
          <p className="text-white lg:text-2xl sm:text-sm mt-4 font-jost lg:w-[800px] sm:w-[350px] mb-20">
            Forging Your Global Business Path Together We support global
            management decision-making and assist in its implementation across
            borders.
          </p>
          <Link
            to="/consultation"
            className="lg:text-xl sm:text-md hover:bg-blue-500 duration-300 ease-in-out uppercase font-jost backGroundCustom  rounded lg:px-6 sm:px-4 lg:py-4 sm:py-2 text-white"
          >
            Get free consultation
          </Link>
        </div>
      </div>

      {/* Swiper */}
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination]}
        className="mySwiper relative z-0"
      >
        {data.map((item, index) => (
          <SwiperSlide key={index}>
            <img
              style={{ width: "100%", height: "800px", objectFit: "cover" }}
              src={item.img}
              alt=""
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MiraiHomeHero;
